import { StyleRules, Theme } from '@material-ui/core';

export default (theme: Theme): StyleRules => ({
  body: {
    '& .MuiDialog-paper': {
      backgroundColor: '#191B25',
      width: '320px',
    },
  },
  button: {
    backgroundColor: '#2E83D9',
    borderRadius: '12px',
    color: 'white',
    fontSize: '1rem',
    height: '4rem',
    textTransform: 'capitalize',
    width: '100%',
  },
  dialogActions: {
    justifyContent: 'center',
    padding: '24px',
  },
  myuserlist: {
    color: '#595B7C',
  },
  title: {
    color: 'white',
  },
});
